import { useMutation, useQueryClient } from "@tanstack/react-query";
import { alertSchemaService } from "../../../services/alertSchemasService";
import type { AlertSchema } from "../../../types";

export const useCreateAlertSchema = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: (input: Omit<AlertSchema, "id" | "system">) => alertSchemaService.create(input),
    onSuccess: () => {
      qc.invalidateQueries({queryKey: ["alert-providers"]})
    },
  });
};
